var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "793.834 561.689 50.863 46.625",
    width: 50.863,
    height: 46.625,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aa3pWV9n8sIMcolors-0 {fill:#FF6049;fill-opacity:1;}.aJ-mlzyO1eFfillColor {fill:#4D4D4D;fill-opacity:1;}.aJ-mlzyO1eFstrokeColor-str {stroke:#313131;stroke-opacity:1;}.companyName {fill:#4D4D4D;fill-opacity:1;}.icon3-str {stroke:#FFAE78;stroke-opacity:1;}"))), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.8633,
    height: 46.6254,
    x: 793.8341,
    y: 561.6888,
    preserveAspectRatio: "none",
    viewBox: "0 4.166999816894531 100 91.66699981689452",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    className: "aa3pWV9n8sIMcolors-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5,12.5h-25c-4.167,0-4.167,0-4.167,4.167v16.667c0,4.167,0,4.167,4.167,4.167h25c4.167,0,4.167,0,4.167-4.167V16.667  C91.667,12.5,91.667,12.5,87.5,12.5z M45.833,4.167H29.167C25,4.167,25,4.167,25,8.333v8.333c0,4.167,0,4.167,4.167,4.167h16.667  c4.167,0,4.167,0,4.167-4.167V8.333C50,4.167,50,4.167,45.833,4.167z M95.833,45.833H62.5c-4.167,0-4.167,0-4.167,4.167v33.333  c0,4.167,0,4.167,4.167,4.167h33.333c4.167,0,4.167,0,4.167-4.167V50C100,45.833,100,45.833,95.833,45.833z M45.833,70.833h-25  c-4.167,0-4.167,0-4.167,4.167v16.667c0,4.167,0,4.167,4.167,4.167h25c4.167,0,4.167,0,4.167-4.167V75  C50,70.833,50,70.833,45.833,70.833z M45.833,29.167H4.167C0,29.167,0,29.167,0,33.333v25C0,62.5,0,62.5,4.167,62.5h41.667  C50,62.5,50,62.5,50,58.333v-25C50,29.167,50,29.167,45.833,29.167z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SmallLogo.f144f3fdeb10d5e1ff41f79161f584cc.svg";